import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _InputLoadingIndicato;
var _excluded = ["checked", "destructive", "enableDropdown", "hintCheckbox", "hintCheckboxProps", "hintText", "inputTooltipDescription", "inputTooltipLabel", "inputTooltipPlacement", "inputTooltipProps", "inputTooltipVariant", "inputValue", "label", "labelTooltipDescription", "labelTooltipLabel", "labelTooltipPlacement", "labelTooltipProps", "labelTooltipVariant", "leadingDropDownMenuOptions", "leadingDropDownSelectedOption", "loading", "multipleInputValues", "onChangeCheckbox", "onInputSearch", "placeholder", "readOnly", "required", "searchOptions", "searchOptionsSize", "size", "type", "typeLeading", "width"];
/* eslint-disable max-lines */
/* eslint-disable sort-keys */
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { styled, useTheme } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import { Checkbox } from '../Checkbox';
import Stack from '@mui/material/Stack';
import { SHADOWS } from '@im/im-theme/constants';
import { MenuItem } from '../MenuItem/MenuItem';
import { Icon } from '../Icon';
import { Tag } from '../Tag';
import { typeLeadingMap } from '../InputDropdown';
import { InputSearchInput } from './internal/InputSearchInput';
import { HelpIconWithTooltip, InputLoadingIndicator } from '../common';
import { getScrollbarStyles } from '../common/getScrollbarStyles';
import Typography from '@mui/material/Typography';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function InputSearch(props) {
  var _props$checked = props.checked,
    checked = _props$checked === void 0 ? false : _props$checked,
    destructive = props.destructive,
    _props$enableDropdown = props.enableDropdown,
    enableDropdown = _props$enableDropdown === void 0 ? false : _props$enableDropdown,
    _props$hintCheckbox = props.hintCheckbox,
    hintCheckbox = _props$hintCheckbox === void 0 ? false : _props$hintCheckbox,
    hintCheckboxProps = props.hintCheckboxProps,
    hintText = props.hintText,
    inputTooltipDescription = props.inputTooltipDescription,
    inputTooltipLabel = props.inputTooltipLabel,
    inputTooltipPlacement = props.inputTooltipPlacement,
    inputTooltipProps = props.inputTooltipProps,
    inputTooltipVariant = props.inputTooltipVariant,
    inputValue = props.inputValue,
    label = props.label,
    labelTooltipDescription = props.labelTooltipDescription,
    labelTooltipLabel = props.labelTooltipLabel,
    labelTooltipPlacement = props.labelTooltipPlacement,
    labelTooltipProps = props.labelTooltipProps,
    labelTooltipVariant = props.labelTooltipVariant,
    leadingDropDownMenuOptions = props.leadingDropDownMenuOptions,
    leadingDropDownSelectedOption = props.leadingDropDownSelectedOption,
    loading = props.loading,
    _props$multipleInputV = props.multipleInputValues,
    multipleInputValues = _props$multipleInputV === void 0 ? false : _props$multipleInputV,
    onChangeCheckbox = props.onChangeCheckbox,
    onInputSearch = props.onInputSearch,
    placeholder = props.placeholder,
    _props$readOnly = props.readOnly,
    readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    searchOptions = props.searchOptions,
    searchOptionsSize = props.searchOptionsSize,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    typeLeading = props.typeLeading,
    width = props.width,
    other = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleInputChange = function handleInputChange(e, value) {
    setOpen(value.length > 0 || type === 'badgeCount');
    onInputSearch(value);
  };
  useEffect(function () {
    if (inputValue.length > 0) {
      var newOptions = [];
      searchOptions.forEach(function (element) {
        if (element.text.toLowerCase().includes(inputValue.toLowerCase())) newOptions.push(element);
      });
      setOpen(!!(newOptions.length && open));
    }
  }, [inputValue, searchOptions, open]);
  return /*#__PURE__*/_jsxs(Stack, {
    "data-element": "Stack",
    "data-component": "InputSearch",
    "data-source-file": "InputSearch.tsx",
    children: [/*#__PURE__*/_jsx(Autocomplete, _extends({
      ListboxComponent: function ListboxComponent(props) {
        return /*#__PURE__*/_jsx("ul", _extends({
          role: "listbox"
        }, props));
      },
      PaperComponent: function PaperComponent(props) {
        return /*#__PURE__*/_jsx(StyledPaper, _extends({}, props));
      },
      disableClearable: readOnly || type === 'badgeCount' && !inputValue,
      forcePopupIcon: !!(inputTooltipDescription || inputTooltipLabel || inputTooltipProps != null && inputTooltipProps.label || inputTooltipProps != null && inputTooltipProps.description) || type === 'badgeCount',
      freeSolo: !enableDropdown,
      getOptionLabel: function getOptionLabel(option) {
        return typeof option === 'string' ? option : option.text;
      },
      inputValue: inputValue,
      multiple: multipleInputValues,
      onBlur: function onBlur() {
        return setOpen(false);
      },
      onClose: function onClose() {
        setOpen(false);
      },
      onInputChange: function onInputChange(event, value) {
        return handleInputChange(event, value);
      },
      open: props.disabled ? false : open,
      openText: "",
      options: searchOptions,
      popupIcon: loading ? _InputLoadingIndicato || (_InputLoadingIndicato = /*#__PURE__*/_jsx(InputLoadingIndicator, {})) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [(inputTooltipDescription || inputTooltipLabel || (inputTooltipProps == null ? void 0 : inputTooltipProps.label) || (inputTooltipProps == null ? void 0 : inputTooltipProps.description)) && !enableDropdown && !props.disabled && /*#__PURE__*/_jsx(HelpIconWithTooltip, {
          tooltipDescription: inputTooltipDescription,
          tooltipLabel: inputTooltipLabel,
          tooltipPlacement: inputTooltipPlacement,
          tooltipProps: inputTooltipProps,
          tooltipVariant: inputTooltipVariant
        }), (type === 'badgeCount' || enableDropdown) && !props.disabled && /*#__PURE__*/_jsx(Icon, {
          color: theme.palette.gray[500],
          iconId: "ChevronDown",
          onClick: function onClick() {
            return setOpen(!open);
          },
          size: 20,
          sx: {
            ml: 2,
            cursor: 'pointer'
          }
        })]
      }),
      renderInput: function renderInput(params) {
        return /*#__PURE__*/_jsx(Stack, {
          children: /*#__PURE__*/_jsx(InputSearchInput, {
            destructive: destructive,
            disabled: props.disabled,
            enableDropdown: enableDropdown,
            hintCheckbox: hintCheckbox,
            hintText: hintText,
            inputValue: inputValue,
            label: label,
            labelTooltipDescription: labelTooltipDescription,
            labelTooltipLabel: labelTooltipLabel,
            labelTooltipPlacement: labelTooltipPlacement,
            labelTooltipProps: labelTooltipProps,
            labelTooltipVariant: labelTooltipVariant,
            leadingDropDownMenuOptions: leadingDropDownMenuOptions,
            leadingDropDownSelectedOption: leadingDropDownSelectedOption,
            onInputClick: function onInputClick() {
              return (type === 'badgeCount' || enableDropdown) && setOpen(!open);
            },
            params: params,
            placeholder: placeholder,
            readOnly: readOnly,
            required: required,
            size: size,
            type: type,
            width: width
          })
        });
      },
      renderOption: function renderOption(item, option, state) {
        return /*#__PURE__*/_jsx(MenuItem, _extends({}, item, option, {
          multiSelect: multipleInputValues,
          selected: state.selected,
          size: searchOptionsSize,
          textLeadingType: typeLeading ? typeLeadingMap[typeLeading] : option.textLeadingType
        }));
      },
      renderTags: function renderTags(value, getTagProps) {
        return value.map(function (option, index) {
          var _getTagProps = getTagProps({
              index: index
            }),
            onDelete = _getTagProps.onDelete;
          return /*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsx(Tag, {
              action: "xClose",
              checked: false,
              icon: option.avatarImg ? 'avatar' : null,
              imageSrc: option.avatarImg,
              isCheckboxEnabled: false,
              label: option.tagLabel || option.text,
              onClose: onDelete,
              sx: {
                maxHeight: '24px'
              }
            })
          });
        });
      },
      sx: {
        '& .MuiOutlinedInput-root': {
          gap: '8px!important'
        },
        '& .MuiIconButton-sizeMedium': {
          '&:hover': {
            backgroundColor: 'unset',
            cursor: 'default'
          }
        },
        pointerEvents: readOnly ? 'none' : 'auto',
        width: width
      }
    }, other, {
      disabled: loading || props.disabled,
      "data-element": "Autocomplete",
      "data-source-file": "InputSearch.tsx"
    })), hintCheckbox && /*#__PURE__*/_jsxs(Stack, {
      alignItems: 'flex-start',
      direction: "row",
      marginTop: "6px",
      spacing: 2,
      children: [/*#__PURE__*/_jsx(Checkbox, _extends({
        checked: checked,
        disabled: loading || props.disabled,
        onChange: onChangeCheckbox
      }, hintCheckboxProps, {
        readOnly: readOnly,
        size: "sm",
        sx: {
          marginTop: '2px !important'
        }
      })), /*#__PURE__*/_jsx(Typography, {
        color: destructive ? theme.palette.error[600] : theme.palette.gray[600],
        variant: "text-sm-regular",
        children: hintText
      })]
    })]
  });
}
var StyledPaper = styled(Paper)(function (_ref) {
  var theme = _ref.theme;
  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".MuiAutocomplete-listbox", _extends({}, getScrollbarStyles(theme, theme.palette.common.white), _defineProperty(_defineProperty(_defineProperty({}, ".menuGroupContainer", _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "&:first-of-type", {
    paddingTop: '38px'
  }), "&:last-child", {
    borderBottom: 0,
    paddingBottom: 0
  }), "borderBottom", "1px solid ".concat(theme.palette.gray[200])), "listStyle", 'none'), "padding", '16px 0px 8px 8px')), "margin", 0), "padding", 0))), "boxShadow", theme.shadows[SHADOWS.lg]), "borderRadius", '8px'), "border", "1px solid ".concat(theme.palette.gray[200])), "padding", '4px 6px 4px 6px'), "marginTop", '4px');
});